export const isPublicArticle = (article) => {
  if (!article || article.status !== "PUBLISHED" || !article.publishedAt) {
    return false;
  }

  const publishedAt = new Date(article.publishedAt);

  return !Number.isNaN(publishedAt.getTime()) && publishedAt <= new Date();
};
